<template>
	<div :class="['map-wrapper', extraClass]">
		<div :class="['app-map', initClass]" id="app-map"></div>
		<!--<div class="app-map-text">Shift and drag to rotate.</div>-->
		<FloorLoader v-if="map"/>
		<LayerLoader v-if="map" />
		<DrawLayer v-if="map"></DrawLayer>

		<ZoneLoader v-if="drawLayer"/>
		<PathLoader v-if="drawLayer"/>
		<LayerToolbar v-if="drawLayer"/>
		<WeatherToolbar v-if="map" />

		<Weather/>


		<GameWorkers v-if="drawLayer"/>
		<Vehicles v-if="assets_loaded && hasVehicles" />
	</div>
</template>

<style scoped lang="scss">
	.app-map-text {
		bottom: 5px;
	}
</style>

<script>

	import Weather from '../Weather.vue'
	import WeatherToolbar from './WeatherToolbar'
	import FloorLoader from './FloorLoader.vue'
	import DrawLayer from './DrawLayer.vue'
	import ZoneLoader from './ZoneLoader.vue'
	import PathLoader from './PathLoader.vue'
	import LayerLoader from './LayerLoader.vue'
	import LayerToolbar from './LayerToolbar.vue'
	import GameWorkers from '../Game/Workers.vue'
	import Vehicles from '../Game/Vehicles.vue'


	export default {
		name: 'Map',
		components: {LayerToolbar, DrawLayer, ZoneLoader, PathLoader, GameWorkers, FloorLoader, Vehicles, LayerLoader, Weather, WeatherToolbar},
	    props: {
	      initClass: String,
	      extraClass: String
	    },
		computed: {
			map: {
				get() { return this.$store.state.map.map; },
				set(value) { this.$store.commit('set_map', {map: value}); }
			},
			layers: {
				get() { return this.$store.state.map.layers; },
				set(value) { this.$store.commit('set_map', {layers: value}); }
			},
			location: {
				get() { return this.$store.state.location; },
			},
			drawLayer() { return this.$store.state.map.drawLayer },
			assets_loaded() { return this.$store.state.assets_loaded},
			hasVehicles() { return Object.keys(this.$finder.all({'type': 'parking'}, this.$store.state.zones)).length > 0}
		},
		mounted: function () {
			this.initMap();
		},
		methods: {
			initMap: function() {
				this.initLayers();

				const center = [this.location.long, this.location.lat];
				this.map = new ol.Map({
					target: 'app-map',
					layers: this.layers,
					view: new ol.View({
						rotation: this.location.rotation,
						center: ol.proj.fromLonLat(center),
						zoom: this.location.zoom
					}),
					interactions: [
						new ol.interaction.DragRotate({condition: ol.events.condition.shiftKeyOnly}),
						new ol.interaction.DragPan(),
						new ol.interaction.MouseWheelZoom(),
						new ol.interaction.PinchZoom(),
						new ol.interaction.PinchRotate(),
					],
					controls: [
						new ol.control.Zoom(),
						new ol.control.ScaleLine(),
					//	new ol.control.Rotate(),
					//	new ol.control.LayerSwitcher()
					],

				});


			},
			initLayers: function() {
				this.layers.push(new ol.layer.Tile({
					visible: true,
					preload: Infinity,
					title: 'Satellite',
					combine: false,
					type: 'base',
					source: new ol.source.BingMaps({
						key: 'AiGPlacWJqU2ue7htTeSa_zdIoFdPbpnwnwe4LFLSkcBBE5k2ZWGyl17ZLQCpM5e',
						imagerySet: 'Aerial',
						// use maxZoom 19 to see stretched tiles instead of the BingMaps
						// "no photos at this zoom level" tiles
						maxZoom: 19
					})
				}));

				this.layers.push(new ol.layer.Tile({
					source: new ol.source.OSM({
						crossOrigin: null
					})
				}));

			}
		}
	}
</script>
